module.exports = __webpack_public_path__ + "img/ustc.e6a5c396.svg";